import type { WorkoutSortOption } from '../../../types';

export function getOrdering(sortOption: WorkoutSortOption, ascending: boolean): string {
  if (sortOption === 'name') {
    return ascending ? 'name' : '-name';
  }
  return '-created_at';
}
